import { Helmet } from "react-helmet-async";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://dietofhappiness.com/#organization",
      name: "Diet of Happiness",
      url: "https://dietofhappiness.com",
      logo: "https://dietofhappiness.com/images/happy-diet-logo.png",
      description: "Diet of Happiness — the free Archetype Test, the SOLO Map and the Couples Map.",
      founder: {
        "@type": "Person",
        "@id": "https://dietofhappiness.com/#founder",
        name: "Rimantė",
        jobTitle: "Founder",
        worksFor: { "@id": "https://dietofhappiness.com/#organization" },
      },
    },
    {
      "@type": "WebSite",
      "@id": "https://dietofhappiness.com/#website",
      url: "https://dietofhappiness.com",
      name: "Diet of Happiness",
      publisher: { "@id": "https://dietofhappiness.com/#organization" },
      inLanguage: "en",
    },
  ],
};

const StructuredData = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
  </Helmet>
);

export default StructuredData;
